import { enumMembers, type ApiSchema } from "../../apiSchema";
import { requestJson } from "../../http/httpClient";
import { readArray, readObject, readOneOf, readString } from "../../http/jsonDecoding";

/**
 * The capability keys a step may require and a capability override may assert, as the
 * installation configures them (capabilities.md CAP-5). The forms offer only these; the
 * web app keeps no list of its own (NFR-13).
 */

export type CapabilityValueType = ApiSchema<"CapabilityValueType">;

const VALUE_TYPES = enumMembers<CapabilityValueType>({ boolean: true, integer: true, string: true });

export interface CapabilityDefinition {
  readonly key: string;
  readonly type: CapabilityValueType;
  readonly description: string;
}

export function readCapabilityVocabulary(projectId: string, signal?: AbortSignal): Promise<readonly CapabilityDefinition[]> {
  return requestJson({
    method: "GET",
    path: `/projects/${encodeURIComponent(projectId)}/content/capability-vocabulary`,
    signal,
    decodeResponse: (body) =>
      readArray(readObject(body, "capability vocabulary")["capabilities"], "capabilities", (item) => {
        const definition = readObject(item, "capability");
        return {
          key: readString(definition, "key"),
          type: readOneOf(definition, "type", VALUE_TYPES),
          description: readString(definition, "description"),
        };
      }),
  });
}
